import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
const DEFAULT_LIGHT_COLOR = [255, 255, 255];
const DEFAULT_LIGHT_INTENSITY = 1.0;
let idCount = 0;
export class AmbientLight {
  constructor(props = {}) {
    _defineProperty(this, "id", void 0);

    _defineProperty(this, "color", void 0);

    _defineProperty(this, "intensity", void 0);

    _defineProperty(this, "type", 'ambient');

    const {
      color = DEFAULT_LIGHT_COLOR
    } = props;
    const {
      intensity = DEFAULT_LIGHT_INTENSITY
    } = props;
    this.id = props.id || "ambient-".concat(idCount++);
    this.color = color;
    this.intensity = intensity;
  }

}
//# sourceMappingURL=ambient-light.js.map